import React, { useMemo } from "react"
import { useParams } from "react-router-dom"
import { Helmet } from "react-helmet"
import { useQuery } from "@tanstack/react-query"

import { API_ENDPOINTS } from "@constants"
import { MODULE_TYPE } from "@utils/profilePage"
import { Box, Inline, Tab, TabList, TabPanel, useTabState, Stack } from "@mos-cat/ds"
import {
  MainContainer,
  PageBlockWrapper,
  PageBlockRow,
  PageBlockRowSection,
  PageBlockHeading,
  PageBlockContent,
  apiClient,
} from "@dit/core-frontend"

import tabsStyles from "@assets/styles/tabs.module.css"
import { CommonUserInfo } from "./components/CommonUserInfo"
import { UserActionsList } from "./components/UserActionsList"
import { Person } from "@components/general"

const ProfileBlock = () => {
  const { id: profileId } = useParams()

  const tabState = useTabState({ selectedId: MODULE_TYPE.WIKI })
  const tabsConfig = useMemo(
    () => [
      {
        id: MODULE_TYPE.WIKI,
        label: "mos.wiki",
        params: { module: MODULE_TYPE.WIKI, profileId },
      },
      // временно скрыть вкладку
      // {
      //   id: MODULE_TYPE.TRACK,
      //   label: "mos.track",
      //   params: { module: MODULE_TYPE.TRACK, profileId },
      // },
    ],
    [profileId],
  )

  const moduleInfoApi =
    tabState.currentId === MODULE_TYPE.TRACK
      ? `${API_ENDPOINTS.userInfoTrack}/${profileId}`
      : `${API_ENDPOINTS.userInfoWiki}/${profileId}`

  const { data } = useQuery({
    queryKey: [`user-profile-${moduleInfoApi}`, tabState.currentId, profileId],
    queryFn: async () => {
      return apiClient.get(moduleInfoApi).then((res) => res.data?.data)
    },
  })

  return (
    <>
      {data?.firstName && <Helmet title={`Профиль · ${data.firstName || "Профиль"} · МосВики`} />}
      <PageBlockWrapper>
        <PageBlockRow place="middle">
          <PageBlockRowSection>
            <PageBlockHeading position="relative">
              <Person
                person={data}
                avatarSize="80"
                textMaxWidth="100%"
                display="flex"
                alignItems="center"
              />
            </PageBlockHeading>
          </PageBlockRowSection>
        </PageBlockRow>
        <PageBlockRow place="bottom">
          <PageBlockRowSection flexGrow="1">
            <PageBlockContent as={Stack} space="20px" flexGrow="1">
              <Box
                display="flex"
                justifyContent="space-between"
                borderBottom="2px solid var(--gray-10)"
              >
                <TabList as={Inline} {...tabState} space="20px" className={tabsStyles.tabsList}>
                  {tabsConfig.map((tab) => (
                    <Tab
                      key={`body-tab-${tab.id}`}
                      className={tabsStyles.tab}
                      {...tabState}
                      id={tab.id}
                      kind="tab-2"
                      vertSize="size-1"
                      borderRadius="0"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gridGap="5px"
                      >
                        {tab.label}
                      </Box>
                    </Tab>
                  ))}
                </TabList>
              </Box>
              <Stack space={0} position="relative" minHeight="30px">
                {tabsConfig.map((tab) => (
                  <TabPanel key={`pages-tabs-${tab.id}`} {...tabState}>
                    <Box display="grid" gridTemplateColumns="35% 65%">
                      <CommonUserInfo data={data} />
                      <UserActionsList
                        params={{ ...tab.params }}
                        isVisible={tabState.currentId === tab.id}
                      />
                    </Box>
                  </TabPanel>
                ))}
              </Stack>
            </PageBlockContent>
          </PageBlockRowSection>
        </PageBlockRow>
      </PageBlockWrapper>
    </>
  )
}

export const UserProfilePage = () => {
  return (
    <>
      <MainContainer>
        <ProfileBlock />
      </MainContainer>
    </>
  )
}
